import { FC, ReactElement, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Decimal from '../../components/decimal'
import Input from '../../components/input'
import Modal from '../../components/modal'
import { Container, Result } from './style'

const ModalImcCalculator: FC<{ setImc: (value: string) => void}> = ({ setImc }): ReactElement | null => {
  const [weight, setWeight] = useState(0)
  const [height, setHeight] = useState(0)
  const history = useHistory()
  const { search } = useLocation()

  const query = new URLSearchParams(search)

  const isOpen = query.get('imcCalc') === 'true'

  const result = useMemo(() => {
    if (weight === 0 || height === 0) return 0

    return (Number(weight) / (Number(height) * 0.01 * Number(height) * 0.01)).toFixed(0)
  }, [weight, height])

  if (!isOpen) return null

  return (
    <Modal
      onClose={() => history.push({ search: '' })}
      onOk={() => {
        history.push({ search: '' })
        setImc(String(result))
      }}
      okButtonText='PREENCHER NO EXAME'
      title='IMC'
    >
      Preencha com os dados necessários
      <Container>
        <Input
          type='tel'
          value={String(height)}
          onChange={(e: { target: { value: number } }) => setHeight(e.target.value || 0)}
          label='Altura (cm)'
        />
        <Decimal
          value={String(weight)}
          onChange={(e: { target: { value: number } }) => setWeight(e.target.value || 0)}
          label='Peso (kg)'
        />
        <Result>Resultado: <span>{result}</span></Result>
      </Container>
    </Modal>
  )
}

export default ModalImcCalculator
